
<template>
  <v-bottom-sheet padless class="text-center" width="100%">
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="elevation-0" width="100%" v-bind="attrs" v-on="on"
        >Transfer Manager</v-btn
      >
    </template>
    <v-tabs v-model="tab">
      <v-tab>Files</v-tab>
      <v-tab>Messages</v-tab>
      <v-spacer></v-spacer>
      <v-icon class="mr-3" color="red" @click="closeUpload()"
        >mdi-close-circle-outline</v-icon
      >
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-list
          width="100%"
          v-if="uploadContainer.length > 0"
          class="scroll-section"
        >
          <v-list-item v-for="tile in percentage" :key="tile.key">
            <v-row>
              <v-col cols="4" class="text-truncate text-left">
                <v-list-item-title :title="tile.key">{{
                  tile.key
                }}</v-list-item-title>
              </v-col>
              <v-col>
                <v-progress-linear
                  striped
                  :value="tile.percent"
                  :color="tile.status ? 'green' : 'red'"
                  height="25"
                >
                  <template v-slot="{ value }">
                    <strong>{{
                      tile.status ? Math.ceil(value) + "%" : "error"
                    }}</strong>
                  </template>
                </v-progress-linear>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
        <v-list width="100%" v-if="uploadContainer.length === 0">
          <v-list-item>
            <v-subheader>No data to show you</v-subheader>
          </v-list-item>
        </v-list>
      </v-tab-item>
      <v-tab-item>
        <v-list width="100%" v-if="msgs.length > 0" class="scroll-section">
          <v-list-item-group>
            <template v-for="(tile, index) in msgs">
              <v-list-item :key="`${index}-${tile.action}-${tile.name}`">
                <v-list-item-content>
                  <v-card-title :title="tile.name" class="text-truncate pa-0">{{
                    tile.name
                  }}</v-card-title>
                  <v-list-item-subtitle
                    v-if="tile.action === 'start'"
                    class="px-3"
                  >
                    <v-row>{{ tile.date }}</v-row>
                    <v-row>
                      <v-icon color="blue">mdi-upload-multiple</v-icon>Start
                      Upload
                    </v-row>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle
                    v-else-if="tile.action === 'end'"
                    class="px-3"
                  >
                    <v-row>{{ tile.date }}</v-row>
                    <v-row>
                      <v-icon color="black">mdi-upload-multiple</v-icon>End
                      Upload
                    </v-row>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle
                    v-else-if="tile.action === 'error'"
                    color="red"
                    class="px-3"
                  >
                    <v-row>{{ tile.date }}</v-row>
                    <v-row>
                      <v-icon color="red">mdi-alert</v-icon>
                      {{ tile.text }}
                    </v-row>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="index + 1 < msgs.length"
                :key="index"
              ></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
        <v-list width="100%" v-if="msgs.length === 0">
          <v-list-item>
            <v-subheader>No data to show you</v-subheader>
          </v-list-item>
        </v-list>
      </v-tab-item>
    </v-tabs-items>
  </v-bottom-sheet>
</template>
<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    tab: null,
  }),
  computed: {
    ...mapState({
      uploadContainer: (state) => state.uploadContainer,
      percentage: (state) => state.percentage,
      msgs: (state) => state.msgs,
    }),
  },
  methods: {
    closeUpload() {
      this.$store.dispatch("resetUpload");
    },
  },
};
</script>
<style scoped>
.scroll-section {
  height: 15em;
  overflow: auto;
}
</style>